import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import NotificationSystem from 'rc-notification';
import { secondaryText } from 'themes/colors';

import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import BasicNotification from 'components/Notification';
import SequenceForm from './SequenceForm';

const shouldOpenSettingsFromQuery = param => (
  new URLSearchParams(param).get('open') === 'settings'
);

class SequenceModal extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    sequence: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.shape({
      search: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: shouldOpenSettingsFromQuery(this.props.location.search),
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({}, n => this.notification = n);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.search !== nextProps.location.search
      && shouldOpenSettingsFromQuery(nextProps.location.search)) {
      this.setState({ isOpen: true });
    }
  }

  componentWillUnmount() {
    if (this.notification) {
      this.notification.destroy();
    }
  }

  onSubmit = () => {
    this.toggle();
    this.showNotification();
  }

  showNotification = () => {
    this.notification.notice({
      content: <BasicNotification
        color="success"
        message="Sequence successfully updated"
      />,
      duration: 2,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  toggle() {
    if (this.state.isOpen && shouldOpenSettingsFromQuery(this.props.location.search)) {
      this.props.history.push({ search: '' });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <Tooltip title="Open Settings">
          <IconButton onClick={this.toggle}>
            <SettingsRoundedIcon style={{ color: secondaryText, opacity: 0.8 }} />
          </IconButton>
        </Tooltip>
        <Dialog
          open={this.state.isOpen}
          onBackdropClick={this.toggle}
          size="large"
        >
          <DialogTitle id="dialog-title" disableTypography>
            Settings
          </DialogTitle>
          <SequenceForm
            toggleModal={this.toggle}
            onSubmit={this.onSubmit}
          />
        </Dialog>
      </div>
    );
  }
}


export default compose(
  withRouter,
  connect(
    state => ({
      sequence: state.sequence,
    }),
    null,
  ),
  withNamespaces('common'),
)(SequenceModal);
